"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buggiano": {
    "4e1dc7ec": [{
      "hkey": "84cab631",
      "slug": "colle-di-buggiano",
      "name": "Colle di Buggiano",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "84cab631",
      "slug": "colle-di-buggiano",
      "name": "Colle di Buggiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eebbdde5": [{
      "hkey": "e5e219a7",
      "slug": "stignano",
      "name": "Stignano",
      "primary": true,
      "skipSearch": false
    }],
    "signano": [{
      "hkey": "e5e219a7",
      "slug": "stignano",
      "name": "Stignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;